module.exports = __webpack_public_path__ + "img/settings-online-payments.75df0097.svg";